module.exports = __webpack_public_path__ + "img/scuba-diving-min.8d78541e.jpg";